import { render, staticRenderFns } from "./ClickFinderPage.vue?vue&type=template&id=a471f744&scoped=true"
import script from "./ClickFinderPage.vue?vue&type=script&lang=js"
export * from "./ClickFinderPage.vue?vue&type=script&lang=js"
import style0 from "./ClickFinderPage.vue?vue&type=style&index=0&id=a471f744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a471f744",
  null
  
)

export default component.exports